import { HttpInterceptorFn, HttpRequest, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoaderService } from '../shared/services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next) => {
  const loaderService = inject(LoaderService);
  console.log('LoaderInterceptor: Intercepting request to', req.url);
  // Skip loader for static assets
  if (req.url.startsWith('assets/') || req.url.includes('/assets/') || req.url.includes('/tenant/gettenants')) {
    return next(req);
  }
  
  // Skip loader for specific endpoints if needed (e.g., polling endpoints)
  const skipLoader = req.headers.get('X-Skip-Loader') === 'true';
  if (skipLoader) {
    return next(req);
  }
  
  // Generate unique request ID
  const requestId = `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  
  // Get loading message from header or use default
  const loadingMessage = req.headers.get('X-Loading-Message') || 'Loading...';
  
  // Show loader when request starts
  loaderService.show(loadingMessage, requestId);
  
  // Execute request and hide loader when complete (success or error)
  return next(req).pipe(
    finalize(() => {
      // Hide loader when request completes (success or error)
      loaderService.hide(requestId);
    })
  );
};

